import React, { useState, useEffect } from "react";
import { Button, TextField, Typography, Box, Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import useWindowSize from "../../../hooks/useWindowSize";
import UploadIcon from "@mui/icons-material/CloudUpload";
import {
  getRequiredValueFromContentObject,
  uploadFile,
} from "../../../utils/utils";
import BackdropLoader from "../../../components/common/BackdropLoader";
import { get, patch } from "../../../services/apiService";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import i18next from "i18next";

const FeaturesPreview = () => {
  //   const [previewImage, setPreviewImage] = useState("");
  const { width } = useWindowSize();
  const isArabic = i18next.language === "ar";
  const { currentLang } = useAuth();
  const userId = localStorage.getItem("userId");
  const { id: userSectionId } = useParams();
  const direction = currentLang === "en" ? "ltr" : "rtl";

  const [featureData, setFeatureData] = useState({
    heading: null,
    description: null,
  });

  const [uploadedImagesUrl, setUploadedImagesUrl] = useState({
    image1: null,
    image2: null,
    image3: null,
  });

  const [headings, setHeadings] = useState({
    image1: "You can directly sell your service or product",
    image2: "With ease, enjoy personalized mail for your business",
    image3: "Technology developed from scratch",
    image4: "",
  });

  const [descriptions, setDescriptions] = useState({
    image1:
      "Your service or product can be added and made available to your customers without complications.",
    image2:
      "Add your custom mail to your domain and to all your employees without the need for a specialist.",
    image3:
      "The development was carried out with international technologies, and you also made custom development with expert touches to be unique in high performance.",
    image4: "",
  });

  const [actualContent, setActualContent] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  // States for image, heading, and description for each of the 3 images

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const handleImageUpload = async (event, imageKey) => {
    const file = event.target.files[0];
    const uploadedImgUrl = await uploadFile(file, onLoading);
    if (file) {
      setUploadedImagesUrl({
        ...uploadedImagesUrl,
        [imageKey]: uploadedImgUrl,
      });
    }
  };

  const handleHeadingChange = (e, imageKey) => {
    setHeadings((prev) => ({
      ...prev,
      [imageKey]: e.target.value,
    }));
  };

  const handleDescriptionChange = (e, imageKey) => {
    setDescriptions((prev) => ({
      ...prev,
      [imageKey]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    //convert the heading, description and images state in this shape
    console.log("uploaded Images url------->", uploadedImagesUrl);
    console.log("current language", currentLang);
    console.log("current language", typeof currentLang);
    if (
      uploadedImagesUrl.image1 &&
      uploadedImagesUrl.image2 &&
      uploadedImagesUrl.image3 &&
      headings.image1 &&
      headings.image2 &&
      headings.image3 &&
      descriptions.image1 &&
      descriptions.image2 &&
      descriptions.image3
    ) {
      console.log("updated headings", headings);
      console.log("updated descriptions", descriptions);
      const updatedContentArray = actualContent.map((contentItem, index) => {
        let updatedTranslations = [...contentItem.translation]; // start with existing translations

        // Check for each type separately and update if needed
        console.log("index", index);
        const realIndex = index % 3;

        const imgValue = uploadedImagesUrl["image" + (realIndex + 1)];
        const headingValue = headings["image" + (realIndex + 1)];
        const descriptionValue = descriptions["image" + (realIndex + 1)];

        if (contentItem.contentType === "img" && imgValue) {
          updatedTranslations.forEach((trans) => {
            if (trans.languageCode === currentLang) {
              trans.languageText = imgValue; // directly modify
            }
          });
        }

        if (contentItem.contentType.includes("h") && headingValue) {
          updatedTranslations.forEach((trans) => {
            if (trans.languageCode === currentLang) {
              trans.languageText = headingValue; // directly modify
            }
          });
          console.log("updated translation", updatedTranslations);
        }

        if (
          (contentItem.contentType === "p" ||
            contentItem.contentType === "text") &&
          descriptionValue
        ) {
          updatedTranslations.forEach((trans) => {
            if (trans.languageCode === currentLang) {
              trans.languageText = descriptionValue; // directly modify
            }
          });
        }

        return {
          ...contentItem,
          translation: updatedTranslations,
        };
      });

      console.log("updated content------>", updatedContentArray);

      const finalObject = { sectionContent: updatedContentArray };

      console.log("Formatted Data:", finalObject);
      const updateContentResponse = await patch(
        `users/${userId}/section/${userSectionId}/content`,
        finalObject,
        {},
        onLoading,
      );
      console.log("update content response--------->", updateContentResponse);
      if (updateContentResponse.status === 200) {
        console.log("need to call api fetch content again-------------->");
        fetchContent();
      }
    } else {
      toast.error(i18next.t("Please Fill all the fields"));
    }
  };

  // const handleChange = (e) => {
  //   setFeatureData({ ...featureData, [e.target.name]: e.target.value });
  // };

  const fetchContent = async () => {
    const response = await get(
      `users/${userId}/section/${userSectionId}`,
      {},
      onLoading,
    );
    // console.log("content response--------->", response?.data?.content);
    const contentResponse = response?.data?.content;

    const imagesContent = contentResponse.filter(
      (content) => content.contentType === "img",
    );
    const textContent = contentResponse.filter(
      (content) =>
        content.contentType === "text" || content.contentType === "p",
    );
    const headingContent = contentResponse.filter((content) =>
      content.contentType.includes("h"),
    );
    if (textContent.length > 3) {
      textContent.shift();
    }
    if (headingContent.length > 3) {
      headingContent.shift();
    }
    const finalArray = [...imagesContent, ...textContent, ...headingContent];
    setActualContent(finalArray);
    if (textContent.length > 3) {
      const featureDescriptionObj = textContent.shift();
      console.log("feature description obj", featureDescriptionObj);
      const featureDescription = featureDescriptionObj?.translation.find(
        (trans) => trans.languageCode === currentLang,
      );
      console.log("found description", featureDescription);
      setFeatureData((prev) => ({
        ...prev,
        description: featureDescription,
      }));
    }

    if (headingContent.length > 3) {
      const featureHeadingObj = headingContent.shift();
      console.log("feature heading obj", featureHeadingObj);
      const featureHeading = featureHeadingObj?.translation.find(
        (trans) => trans.languageCode === currentLang,
      );
      setFeatureData((prev) => ({
        ...prev,
        heading: featureHeading,
      }));
    }
    // headingContent.shift();

    console.log("after removing first item from content arrat-------------->");
    console.log("images content----------->", imagesContent);
    console.log("Heading content --------------->", headingContent);
    console.log("text content --------------->", textContent);

    if (imagesContent.length > 0) {
      for (let i = 0; i < imagesContent.length; i++) {
        const image = getRequiredValueFromContentObject(
          imagesContent[i],
          currentLang,
        );

        setUploadedImagesUrl((prevUploadedImage) => ({
          ...prevUploadedImage,
          [`image${i + 1}`]: image.replace(/\n/g, "").trim(),
        }));
      }
    }

    if (headingContent.length > 0) {
      for (let i = 0; i < headingContent.length; i++) {
        const heading = getRequiredValueFromContentObject(
          headingContent[i],
          currentLang,
        );

        setHeadings((prevHeading) => ({
          ...prevHeading,
          [`image${i + 1}`]: heading.replace(/\n/g, "").trim(),
        }));
      }
    }

    if (textContent.length > 0) {
      for (let i = 0; i < textContent.length; i++) {
        const text = getRequiredValueFromContentObject(
          textContent[i],
          currentLang,
        );
        const trimmedText = text.replace(/\n/g, "").trim();
        setDescriptions((prevDescription) => ({
          ...prevDescription,
          [`image${i + 1}`]: trimmedText,
        }));
      }
    }
  };
  useEffect(() => {
    fetchContent();
  }, [currentLang]);

  useEffect(() => {
    console.log(" updated headings--------->", headings);
    console.log(" updated descriptions---------->", descriptions);
    console.log(
      " updated uploaded image url-------------->",
      uploadedImagesUrl,
    );
    console.log(" features data-------------->", featureData);
  }, [headings, descriptions, uploadedImagesUrl, featureData]);

  return (
    <Box p={1} dir={direction}>
      <Card
        sx={{ display: "flex", alignItems: "center", p: 2, marginTop: "1%" }}
      >
        <Box sx={{ borderRadius: "50%", marginRight: 2 }}>
          <Typography
            sx={{
              fontFamily: "Tajawal-Bold",
              color: "#0A0A0A",
              fontWeight: 700,
              fontSize: width > 900 ? "26px" : "18px",
            }}
          >
            {i18next.t("Features Preview")}
          </Typography>
        </Box>
      </Card>
      {isLoading && <BackdropLoader />}
      <Grid container spacing={2} sx={{ marginTop: "2%" }}>
        {/* Left Side - Page Preview */}
        <Grid item size={{ sm: 12 }}>
          <Box
            p={3}
            sx={{
              height: "auto",
              width: "100%",
              border: "1px solid #ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "white",
            }}
          >
            {/* Static Headings */}
            <Grid
              container
              spacing={2}
              sx={{ width: "100%", padding: width > 450 ? "8%" : "1%" }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    color: "black",
                    textAlign: "center",
                    fontSize:
                      width > 1440 ? "50px" : width > 900 ? "24px" : "16px",
                  }}
                >
                  {i18next.t(
                    "Features that live up to your taste and enable you to work",
                  )}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "Tajawal-Regular",
                    color: "black",
                    marginTop: "1rem",
                    textAlign: "center",
                    fontSize:
                      width > 1440 ? "20px" : width > 900 ? "18px" : "16px",
                  }}
                >
                  {i18next.t(
                    "With a few clicks, you will have launched your electronic identity in the Internet space, with an unprecedented quality that has been meticulously developed to meet the most important details.",
                  )}
                </Typography>
              </Grid>
              <Grid container spacing={2} sx={{ width: "100%" }}>
                {["image1", "image2", "image3"].map((imageKey, index) => (
                  <Grid
                    key={imageKey}
                    item
                    size={{ xs: 12, sm: 12, md: 6, lg: 4 }} // Adjust column size based on screen width
                  >
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "white",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        borderRadius: "10px",
                        overflow: "hidden",
                        height: "100%",
                      }}
                    >
                      {/* Image */}
                      {uploadedImagesUrl[imageKey] ? (
                        <Box
                          component="img"
                          src={uploadedImagesUrl[imageKey]}
                          alt={`Preview ${imageKey}`}
                          sx={{
                            width: "100%",
                            height: width > 900 ? "280px" : "250px",
                            objectFit: "cover",
                            padding: "4%",
                            borderRadius: "8px",
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            width: "100%",
                            height: "200px",
                            backgroundColor: "#f4f4f4",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "10px",
                          }}
                        >
                          <Typography sx={{ color: "#ccc" }}>
                            {i18next.t("No Image Uploaded")}
                          </Typography>
                        </Box>
                      )}

                      {/* Heading and Description */}
                      <Box sx={{ p: 2 }}>
                        <Typography
                          sx={{
                            fontSize: width > 900 ? "24px" : "16px",
                            fontFamily: "Tajawal-Bold",
                            color: "#0A0A0A",
                          }}
                        >
                          {headings[imageKey]}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontFamily: "Tajawal-Regular",
                            color: "grey",
                            marginTop: "0.5rem",
                          }}
                        >
                          {descriptions[imageKey]}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* Dynamic Image Content */}
          </Box>
        </Grid>

        {/* Right Side - Image Uploaders and Form */}
        <Grid item size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            {/* Heading and Description Inputs for Each Image */}
            {/* <TextField
          
                  variant="outlined"
                  fullWidth
                  name='heading'
                  sx={{ marginTop: { sm: "1%", xs: "6%" } }}
                  value={featureData?.heading?.languageText}
                  onChange={handleChange}
                />
                  <TextField
               

                  variant="outlined"
                  fullWidth
                  name='description'
                  sx={{ marginTop: { sm: "1%", xs: "6%" } }}
                  value={featureData?.description?.languageText}
                  onChange={handleChange}
                /> */}

            {["image1", "image2", "image3"].map((imageKey) => (
              <Box key={imageKey} width="100%">
                <Button
                  key={imageKey}
                  variant="outlined"
                  component="label"
                  sx={{
                    width: "100%",
                    height: "70px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px dashed #4789C5",
                    color: "#4789C5",
                    fontSize: "1rem",
                    marginTop: "1.7%",
                    fontFamily: "Tajawal-Regular",
                    "&:hover": { border: "2px solid #4789C5" },
                  }}
                >
                  {uploadedImagesUrl[imageKey]
                    ? i18next.t("Image Uploaded")
                    : i18next.t("Drag & Drop files or Browse")}
                  <UploadIcon
                    sx={{
                      marginLeft: !isArabic && "1%",
                      marginRight: isArabic && "1%",
                      color: "#4789C5",
                    }}
                  />
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleImageUpload(e, imageKey)}
                  />
                </Button>

                <TextField
                  label={`Heading for ${imageKey}`}
                  variant="outlined"
                  fullWidth
                  sx={{ marginTop: { sm: "3%", xs: "6%" } }}
                  value={headings[imageKey]}
                  onChange={(e) => handleHeadingChange(e, imageKey)}
                />
                <TextField
                  label={`Description for ${imageKey}`}
                  variant="outlined"
                  fullWidth
                  sx={{ marginTop: { sm: "3%", xs: "6%" } }}
                  value={descriptions[imageKey]}
                  onChange={(e) => handleDescriptionChange(e, imageKey)}
                  multiline
                  rows={2}
                />

                {/* Image Uploader */}
              </Box>
            ))}

            {/* Buttons for Save and Cancel */}
            <Box justifyContent="center" textAlign="center" width="100%">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#3173B1",
                  color: "white",
                  fontWeight: "bold",
                  width: width > 600 ? "140px" : "100px",
                  "&:hover": { backgroundColor: "#3173B1" },
                }}
                onClick={handleSubmit}
              >
                {i18next.t("Save Changes")}
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: "black",
                  borderColor: "black",
                  width: width > 600 ? "140px" : "100px",
                  marginLeft: !isArabic && "1%",
                  marginRight: isArabic && "1%",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#f2f2f2" },
                }}
              >
                {i18next.t("Cancel")}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeaturesPreview;
